const optionalSubjects = [
  {
    title: "Anthropology",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Geography",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Economics",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Chemistry",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Botony",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Philosophy",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Commerce And Accountancy",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "History",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Public Administration",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "PSIR",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Psychology",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Physics",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Zoology",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Statistics",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Sociology",
    description: "Click to learn more about this optional subject.",
  },
  {
    title: "Civil Engineering",
    description: "Click to learn more about this optional subject.",
  }
,
  {
    title: "Animal Husbandry and Veterinary Science",
    description: "Click to learn more about this optional subject.",
  }
,
  {
    title: "Electrical Engineering",
    description: "Click to learn more about this optional subject."
  }
,
  {
    title: "Geology",
    description: "Click to learn more about this optional subject."
  }
,
  {
    title: "Law",
    description: "Click to learn more about this optional subject."
  }
];

export default optionalSubjects;
